import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { UserGroupsFormVM } from './user-groups-form.viewmodel';
import { UserGroupsFormPresentation } from './_user-groups-form-presentation/user-groups-new-form-presentation';

interface IProps {
    fetchUserGroupsList: () => void;
    closeEditGroupForm?: (userGroupId: number) => void;
    userGroupId?: number;
    accountId: number;
}

const UserGroupsFormContainer = withViewModel(
    UserGroupsFormPresentation,
    (props: IProps) => {
        const { fetchUserGroupsList, closeEditGroupForm, accountId, userGroupId } = props;
        const userGroupsFormVM = new UserGroupsFormVM(accountId, fetchUserGroupsList, closeEditGroupForm);
        userGroupsFormVM.initGroup(userGroupId);
        return userGroupsFormVM;
    },
    () => []
);

export { UserGroupsFormContainer as UserGroupsForm };
